module.exports = __webpack_public_path__ + "img/infinity-kingdom.1f3d409.jpg";